import { render, staticRenderFns } from "./DadosIntegralizacao.vue?vue&type=template&id=783a1236&"
import script from "./DadosIntegralizacao.vue?vue&type=script&lang=js&"
export * from "./DadosIntegralizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports